export default "__VITE_ASSET__BiGGKjHr__"